import React, { FC } from 'react';
import { Breadcrumb as BaseBreadcrumb, BreadcrumbProps } from 'antd';
import cx from 'classnames';

import styles from './styles.module.css';

const Breadcrumb: FC<BreadcrumbProps> = ({ className, ...props }) => (
  <BaseBreadcrumb className={cx(styles.root, className)} {...props} />
);

export default Breadcrumb;
